import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-822f6f7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "box" }
const _hoisted_2 = { class: "course-introduce" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " 内容介绍 ", -1))
const _hoisted_4 = { class: "course-introduce-content" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://g.gsxcdn.com/1644056387_cir59juu.png" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://g.gsxcdn.com/1644056386_1wccv9yf.png" }, null, -1))
const _hoisted_7 = { class: "course-catalog" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "title" }, " 内容大纲 ", -1))
const _hoisted_9 = { class: "course-week" }
const _hoisted_10 = { class: "week-info" }
const _hoisted_11 = { class: "right" }
const _hoisted_12 = {
  class: "day-info",
  style: {"font-size":"15px"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: "https://g.gsxcdn.com/1644056388_toi1tpf1.png" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("ul", _hoisted_4, [
        _createElementVNode("li", null, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_ctx.courseInfo.summary1), 1)
        ]),
        _createElementVNode("li", null, [
          _hoisted_6,
          _createElementVNode("span", null, _toDisplayString(_ctx.courseInfo.summary2), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      _hoisted_8,
      _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.courseInfo.courseLevelIntroduce), 1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courseInfo.weekList, (item, index) => {
        return (_openBlock(), _createElementBlock("ul", {
          key: index,
          class: "course-week-content"
        }, [
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, [
                _hoisted_13,
                _createTextVNode(" " + _toDisplayString(item.subjectName), 1)
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.courseList, (item1, index1) => {
                return (_openBlock(), _createElementBlock("p", {
                  key: index1,
                  class: "day-info"
                }, _toDisplayString(item1), 1))
              }), 128))
            ])
          ])
        ]))
      }), 128))
    ])
  ]))
}